import { Injectable } from '@angular/core';

export interface CopilotSettingsPayload {
  speakerLanguage: string;
  avatarLanguage: string;
  avatarDialect: string;
  systemLanguage: string;
}

export const COPILOT_SETTINGS_STORAGE_EVENT = 'ait-copilot-settings-changed';
export const SPEAKER_LANGUAGE_KEY = 'ait-speaker-language';
export const AVATAR_LANGUAGE_KEY = 'ait-avatar-language';
export const AVATAR_DIALECT_KEY = 'ait-avatar-dialect';
export const SYSTEM_LANGUAGE_KEY = 'appLang';
export const DEFAULT_AVATAR_DIALECT = 'msa';
export const DEFAULT_COPILOT_SPEAKER_LANGUAGE = 'en-US';
export const DEFAULT_COPILOT_AVATAR_LANGUAGE = 'en-US';
export const DEFAULT_COPILOT_SYSTEM_LANGUAGE = 'en';

@Injectable({ providedIn: 'root' })
export class CopilotSettingsService {
  getSettings(): CopilotSettingsPayload {
    return {
      speakerLanguage: localStorage.getItem(SPEAKER_LANGUAGE_KEY) ?? DEFAULT_COPILOT_SPEAKER_LANGUAGE,
      avatarLanguage: localStorage.getItem(AVATAR_LANGUAGE_KEY) ?? DEFAULT_COPILOT_AVATAR_LANGUAGE,
      avatarDialect: localStorage.getItem(AVATAR_DIALECT_KEY) ?? '',
      systemLanguage: localStorage.getItem(SYSTEM_LANGUAGE_KEY) ?? DEFAULT_COPILOT_SYSTEM_LANGUAGE,
    };
  }

  saveSettings(settings: CopilotSettingsPayload): void {
    localStorage.setItem(SPEAKER_LANGUAGE_KEY, settings.speakerLanguage);
    localStorage.setItem(AVATAR_LANGUAGE_KEY, settings.avatarLanguage);
    localStorage.setItem(AVATAR_DIALECT_KEY, settings.avatarDialect || '');
    localStorage.setItem(SYSTEM_LANGUAGE_KEY, settings.systemLanguage || DEFAULT_COPILOT_SYSTEM_LANGUAGE);
    window.dispatchEvent(new CustomEvent(COPILOT_SETTINGS_STORAGE_EVENT));
  }
}
